import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import MatchList from './components/MatchList';
import ThemeToggle from './components/ThemeToggle';

function App() {
  return (
    <Router basename="/mecze">
      <div className="App">
        <div className="header">
          <div className="header-brand">
            <img src={process.env.PUBLIC_URL + '/logo-header.png'} alt="Logo" className="header-logo" />
            <div className="header-title">
              <h1>Mecze w TV</h1>
              <span className="header-subtitle">Powered by FlashScore</span>
            </div>
          </div>
          <div className="theme-toggle-container">
            <ThemeToggle />
          </div>
        </div>
        <main className="main-content">
          <Routes>
            <Route path="/" element={<MatchList />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;